import propsResolver from "@insightfulscience/shared-utils/fn/props-resolver";
import renewableSubscriptionsProvider from "../../providers/renewableSubscriptionsProvicder";
import GET_COUNTRIES from "./get-countries.graphql";
import GET_CUSTOMER from "./get-customer.graphql";

export const services = {
	renewableSubscriptions: renewableSubscriptionsProvider,
};

export const countries = (_, { gqlClient }) =>
	gqlClient(GET_COUNTRIES).then(result => result.getCountries);

export const customer = (_, { gqlClient }) =>
	gqlClient(GET_CUSTOMER).then(result => result.getCurrentCustomer);

export const billingInfo = (_, { storageService }) => storageService.billingInfo.read();

export const hasRenewableSubscriptions = ({ query }, { renewableSubscriptions }) =>
	query?.confirmed != null
		? Promise.resolve(false)
		: renewableSubscriptions().then(subscriptions => subscriptions.length > 0);

export default propsResolver({
	countries,
	customer,
	billingInfo,
	hasRenewableSubscriptions,
});
